import { styled } from "../../services/stitchesConfig";

export const AreaCSS = styled('div', {})